module.exports = __webpack_public_path__ + "media/rise1.cbe4ede1.mp4";